import { defineMessages } from "react-intl";

import {
	hasOccurredMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/liver-related-complications/varicealBleeding";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	varicealBleeding: {
		id: "form.varicealBleeding",
		defaultMessage: "Varixvérzés"
	},
	hasOccurred: {
		id: "form.varicealBleeding.hasOccurred",
		defaultMessage: "Volt-e a betegnek varixvérzése korábban?"
	}
});

const fields: { [key: string]: FieldData } = {
	hasOccurred: {
		type: "field",
		path: ["hasOccurred"],
		label: messages.hasOccurred,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hasOccurredMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.hasOccurred }] }]
};

export const node: LeafNode = {
	id: "varicealBleeding",
	value: {
		title: messages.varicealBleeding,
		validator,
		fieldset,
		isImportant: false
	}
};
